import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { cabecera } from "./components/cabecera.component";

import { bodyComponent } from "./components/body.component";

import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { httpService } from './service/servicio';
import { LoginComponent } from './login/login.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { ExpedientesComponent } from './expedientes/expedientes.component';
import { parametros } from './datos/parametros';
import { MenuComponent } from './menu/menu.component';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { DatosmaquinasComponent } from './datosmaquinas/datosmaquinas.component';
import { PosicionesComponent } from './posiciones/posiciones.component';
import { DatosposicionesComponent } from './datosposiciones/datosposiciones.component';
import { ClientesComponent } from './clientes/clientes.component';
import { DatoscclientesComponent } from './datoscclientes/datoscclientes.component';
import { ArticulosComponent } from './articulos/articulos.component';
import { DatosarticulosComponent } from './datosarticulos/datosarticulos.component';
import { TarifasComponent } from './tarifas/tarifas.component';
import { MarcasComponent } from './marcas/marcas.component';
import { ModelosComponent } from './modelos/modelos.component';
import { RecaudacionesComponent } from './recaudaciones/recaudaciones.component';
import { CargasComponent } from './cargas/cargas.component';
import { VisitasComponent } from './visitas/visitas.component';
import { FacturasComponent } from './facturas/facturas.component';
import { LotesComponent } from './lotes/lotes.component';
import { CargasOperadorComponent } from './cargas-operador/cargas-operador.component';


@NgModule({
  declarations: [
    AppComponent,
    cabecera,
    bodyComponent,
    LoginComponent,
    ExpedientesComponent,
    MenuComponent,
    DatosmaquinasComponent,
    PosicionesComponent,
    DatosposicionesComponent,
    ClientesComponent,
    DatoscclientesComponent,
    ArticulosComponent,
    DatosarticulosComponent,
    TarifasComponent,
    MarcasComponent,
    ModelosComponent,
    RecaudacionesComponent,
    CargasComponent,
    VisitasComponent,
    FacturasComponent,
    LotesComponent,
    CargasOperadorComponent


  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    NgxPaginationModule,
    Ng2OrderModule,
    ToastModule.forRoot()

  ],
  providers: [

    httpService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {


 }



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/app.module.ts